import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { BitwerxOfferingSubOfferingPanelProps } from './types';
import { Button, CollapsiblePanel } from '@v2/components';
import BitwerxSubOfferingCard from '../BitwerxSubOfferingCard';
import { styles } from './styles';

const BitwerxOfferingSubOfferingPanel: React.FC<
  BitwerxOfferingSubOfferingPanelProps
> = ({ offering, onAddSubOffering, onDeleteSubOffering, canModify = true }) => {
  const subOfferings = offering.subOfferings ?? [];
  const count = subOfferings.length;
  const hasSubOfferings = count > 0;

  return (
    <CollapsiblePanel title="Sub Offerings" defaultExpanded={false}>
      <div className={styles.header}>
        <span className={styles.description}>
          {count > 0
            ? `${count} ${count === 1 ? 'sub offering' : 'sub offerings'}`
            : 'No sub offerings for this offering'}
        </span>
        {canModify && onAddSubOffering && (
          <Button
            variant="ghost-success"
            size="sm"
            onClick={onAddSubOffering}
            icon={<FontAwesomeIcon icon={faPlus} />}
          >
            Add Sub Offerings
          </Button>
        )}
      </div>
      {hasSubOfferings && (
        <div className={styles.grid}>
          {subOfferings.map((sub) => (
            <BitwerxSubOfferingCard
              key={sub.id}
              subOffering={sub}
              onDelete={canModify ? onDeleteSubOffering : undefined}
            />
          ))}
        </div>
      )}
    </CollapsiblePanel>
  );
};

export default BitwerxOfferingSubOfferingPanel;
